import { Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { SectionContainer, Section } from '@components/Section';
import Img from '@components/Img';
import Styles from './Styles.module.scss';

const defaultStrategies = [
  {
    title: 'Account Based Marketing',
    image: '/images/vertical-skills/account-based-marketing.svg',
  },
  { title: 'Customer Data Platforms', image: '/images/vertical-skills/data-platforms.svg' },
  { title: 'AI Enhanced Ads', image: '/images/vertical-skills/enhance-ads.svg' },
  { title: 'Personalization Strategies', image: '/images/vertical-skills/strategies.svg' },
  { title: 'And Various Others', image: '/images/vertical-skills/others.svg' },
];

const colors = [Styles.purple, Styles.teal, Styles.sea];

const Item = ({ image, title, index }) => (
  <div className={Styles.card}>
    {image ? (
      <Img className={Styles.image} alt={title} src={image} height={75} width={75} />
    ) : (
      <div className={classNames(Styles.itemPlacement, colors[index % 3])}>{index + 1}</div>
    )}

    <div className={Styles.name}>{title}</div>
  </div>
);

const KeySkillSummary = ({ data, style, containerClassName, className }) => {
  const strategies = data?.internalStrategySections || defaultStrategies;

  return (
    <SectionContainer style={style} className={containerClassName}>
      <Section
        title={data?.title || `Find World-Class Talent to Implement Emerging Strategies for Growth`}
        subtitle={
          data?.description ||
          `Tap on the knowledge pool of our experts who understand new technologies deeply and leverage on them to deliver real impact to your projects.`
        }
        textColor={Section.Color.WHITE}>
        <div className={classNames(Styles.grid, strategies?.length > 5 && Styles.wrappingGrid)}>
          {strategies?.map((item, idx) => (
            <Item
              key={idx}
              index={idx}
              title={item.title}
              image={item?.imageFile?.url || item.image}
            />
          ))}
        </div>
      </Section>
    </SectionContainer>
  );
};

KeySkillSummary.propTypes = {
  data: PropTypes.object,
};

export default KeySkillSummary;
